module.exports = __webpack_public_path__ + "img/banner-bottom.386274cf.png";